
<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <Banner />
    <HelloWorld class="mygrid" msg="Welcome to Your Vue.js App" :rows="myrows" :dataItems="mydata"/>
    
    <div class="segmentHeader1"><h1 class="aa" style="font-size:18px"></h1></div>
    <!-- <SNS /> -->
    <!-- <button @click="onAndroidClick"> 调用Android </button> -->
    
    <!-- <div class="segmentHeader2"><h1 class="aa" style="font-size:20px">旅行采风</h1></div> -->
    
  </div>
</template>



<script>
import HelloWorld from './components/HelloWorld.vue'
import Banner from './components/Banner.vue'
import axios from 'axios'
//import { jsonp } from 'vue-jsonp'
 
// import SNS from './components/SNS.vue'

//import avatar from '@/assets/logo.png'

export default {
  name: 'App',
  components: {
    HelloWorld,
    Banner,
    // SNS
  },   
  //https://smskb.oss-cn-beijing.aliyuncs.com/img/12306.png
  data() {
      return {
        myrows:3,
        mydata:[
        
        // {"title":"公交","icon":require('@/assets/smskb-discovery-img/bus.png'),"link":"http://mbus.mapbar.com/beijing"},
        //{"title":"机票","icon":require('@/assets/smskb-discovery-img/flight.png'),"link":"http://touch.qunar.com/h5/flight/?bd_source=shengming_adr"},
        //{"title":"酒店","icon":require('@/assets/smskb-discovery-img/hotel.png'),"link":"http://touch.qunar.com/h5/hotel/?bd_source=shengming_adr"},
        //{"title":"旅游","icon":require('@/assets/smskb-discovery-img/package.png'),"link":"https://touch.qunar.com/hotelindex?bd_source=shengming_adr&ouid="},
        // {"title":"铁路新闻","icon":require('@/assets/smskb-discovery-img/12306.png'),"link":"http://www.peoplerail.com/rail/"},
        //{"title":"旅行采风","icon":require('@/assets/smskb-discovery-img/bbs.png'),"link":"http://smskb-forum.qianyiyule.top"},
        // {"title":"今日头条","icon":require('@/assets/smskb-discovery-img/jrtt.png'),"link":"https://m.toutiao.com/?W2atIF=1","isapp":true},
        // {"title":"58同城","icon":require('@/assets/smskb-discovery-img/58.jpg'),"link":"http://58.com","isapp":true},
        // {"title":"汽车之家","icon":require('@/assets/smskb-discovery-img/qczj.png'),"link":"https://m.autohome.com.cn/","isapp":true},
        //{"title":"高铁线路图","icon":require('@/assets/smskb-discovery-img/route2.png'),"link":"http://fx.smskb.com/gtsyt.png"},
        {"title":"高铁线路图","icon":require('@/assets/smskb-discovery-img/route2.png'),"link":"#","native":{"actionType":"class","class":"smskb.com.activity.IEBrowserActivity","bundle":{"url":"http://fx.smskb.com/gtsyt.png","title":"高铁线路图","fixTitle":true}}},
        {"title":"血压笔记","icon":require('@/assets/smskb-discovery-img/health128.png'),"link":"#","isapp":true,"native":{"actionType":"apk","package":"com.sm.healthkit","markets":[{"name":"华为市场","package":"com.huawei.appmarket"},{"name":"小米市场","package":"com.xiaomi.market"},{"name":"OPPO市场","package":"com.oppo.market"},{"name":"应用宝","package":"com.tencent.android.qqdownloader"},{"name":"360手机助手","package":"com.qihoo.appstore"}],"prompt":"血压笔记，即将使用应用市场打开详情页面","page":{"url":"https://www.pgyer.com/xueyabiji","prompt":"血压笔记，即将使用浏览器打开详情页面"}}},
        {"title":"快速抢票","icon":require('@/assets/smskb-discovery-img/qiangpiao.png'),"link":"#","isapp":false,"native":{"actionType":"class","class":"smskb.com.activity.l12306.qiangpiao.ActivityQP"}},
        // {"title":"车站大屏","icon":require('@/assets/smskb-discovery-img/daping4.png'),"link":"#","isapp":false,"native":{"actionType":"class","class":"smskb.com.activity.StationBigScreenActivity"}},
        {"title":"接站神器","icon":require('@/assets/smskb-discovery-img/zimu.png'),"link":"#","isapp":false,"native":{"actionType":"class","class":"smskb.com.activity.JieZhanShanPingActivity"}},
        {"title":"天气预报","icon":require('@/assets/smskb-discovery-img/weather_logo.png'),"link":"#","native":{"actionType":"class","class":"smskb.com.activity.IEBrowserActivity","bundle":{"url":"https://widget-page.qweather.net/h5/index.html?md=0123456&bg=1&lc=101010100&key=9a8fd07c691e4a7bbf02ce42d2e25098&v=_1648702095224","title":"全国天气预报","fixTitle":true}}},

       
        ],

        //http://touch.qunar.com/h5/flight/?bd_source=shengming_adr

      }
    },
  
  methods: {
  getFormatedDate(date){
    let year=date.getFullYear();
    let month=date.getMonth()+1;
    let day=date.getDate();
    let rq=year.toString().concat((month<10?"0"+month:month),(day<10?"0"+day:day));

    return parseInt(rq);
  },
  onAndroidClick(){
    // this.mydata[0].title='哈哈哈哈'
    // console.log('asdfasdf')
    // window.smskb.jumpToActivity('hello','world')    
  }
},
mounted: function () {
  // 2021-11-15 用上了vue-router获取参数
  
  //console.log("print router===========");
  //console.log(this.$router);
  //console.log("print router.query");
  let params=this.$route.query;
  //console.log("params=>",params)
  let url="http://smskb.oss-cn-beijing.aliyuncs.com/smskb-discovery-settings.json"

  if (params!=undefined && JSON.stringify(params) != "{}"){
    let channel=params.distchannel
    let brand=params.brand
    let dataver=params.dataver

    axios.get(url).then(res=>{
      //console.log("配置=>",res.data)
      let enable=res.data.enable
      let aVer=res.data.dataver
      let aBrand=res.data.brand

      //console.log("ver=>",dataver,"aVer=>",aVer,"同一个版本号=>",(dataver==aVer),"enable=>",enable)
      //console.log(aBrand.includes("*"))

      if (enable==true && (dataver==aVer || "*"==aVer)){
        
        if (aBrand.includes("*") || (aBrand.includes(brand) || aBrand.includes(channel))){
          this.mydata.forEach((item,index)=>{
            if (item.isapp) this.mydata.splice(index,1) // 从数组中移除
          })
          }
        }
    }).catch(err=>{
      console.log(err)
    })

    }



},



}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  padding: 10px;
}
.aa{
  /* text-align: left; */
  /* background-color: red; */
}
.mygrid{
  margin-top: 0px;
  margin-bottom: 10px;
}
.segmentHeader1{
  margin-top: 10px;
}
.segmentHeader2{
  margin-top: 10px;
}
</style>
